import React, { useEffect, useRef } from 'react';
import { avatarMenuItems } from '../utils/uiHelpers';
import './AvatarMenu.css';

interface AvatarMenuProps {
  x: number;
  y: number;
  onClose: () => void;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({ x, y, onClose }) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div 
      ref={menuRef}
      className="avatar-context-menu"
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      {avatarMenuItems.map((item, idx) => (
        <div
          key={idx}
          className="avatar-menu-item"
          onClick={() => { item.action(); onClose(); }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default AvatarMenu;
